import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=0e85ac1a&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/elements/_button.scss?vue&type=style&index=0&id=0e85ac1a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e85ac1a",
  null
  
)

export default component.exports